import PropTypes from "prop-types";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";

import { Button, withStyles } from "@material-ui/core";

import API from "../../API";
import { withSnackbar } from "../../HOC/withSnackbar";
import { FilledTextField } from "../../components/FormElements";
import Typography from "../../components/Helpers/Typography";
import CenterWidget from "../../components/Layout/CenterWidget";
import WorkflowWrapper from "../../components/Layout/WorkflowWrapper";
import { loginStyles } from "./sharedStyles";
import { validateEmail } from "../../services/misc.service";

export const EnterEmail = (props) => {
  const { classes, t, setSnackbarMessage } = props;

  const [email, setEmail] = useState("");
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [dirty, setDirty] = useState(false);
  const handleChange = (e) => setEmail(e.target.value);
  const handleSubmit = () => {
    try {
      if (!validateEmail(email)) throw new Error("Invalid Email");
      API.auth.requestNewPassword(email);
      setSnackbarMessage(t("User.EmailSent"));
      setShouldRedirect(true);
    } catch (error) {
      setSnackbarMessage(error.message);
    }
  };
  return shouldRedirect ? (
    <Redirect to="/" />
  ) : (
    <WorkflowWrapper title="User.ChangePassword">
      <CenterWidget title="User.EnterEmail">
        <Typography className={classes.resetInstructions}>
          {t("User.EmailResetInstructions")}
        </Typography>
        <form>
          <FilledTextField
            value={email}
            onChange={handleChange}
            type="email"
            label={t("User.EmailAddress")}
            error={dirty && !validateEmail(email)}
            onBlur={() => setDirty(true)}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmit();
              }
            }}
          />
          <Button
            className={classes.submit}
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
          >
            {t("User.Send")}
          </Button>
        </form>
      </CenterWidget>
    </WorkflowWrapper>
  );
};

EnterEmail.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  setSnackbarMessage: PropTypes.func.isRequired,
};

export default withTranslation("common")(withStyles(loginStyles)(withSnackbar(EnterEmail)));
